// extracted by mini-css-extract-plugin
module.exports = {"pdfLink":"PdfLink_pdfLink__FRfeR","icon":"PdfLink_icon__Kiv33","label":"PdfLink_label__AKZpw"};